/*
 * Copyright 2023 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */

export const UTM_KEYS: string[] = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
];

export const getUtmValues = (queryString: string): { [k: string]: string } => {
    const queryParams = new URLSearchParams(queryString);
    const utmValues: { [k: string]: string } = {};

    UTM_KEYS.forEach((k) => {
        if (queryParams.has(k)) {
            utmValues[k] = queryParams.get(k) as string;
        }
    });

    return utmValues;
};

export const SOCIAL_LOGIN_IDS = {
    GITHUB: "github",
    GOOGLE: "google-oauth2",
};
export const LOCAL_STORAGE_SOCIAL_USER_METADATA_KEY =
    "SOCIAL_LOGIN_USER_METADATA";

export const getFirstLastNameFromString = (name: string): string[] => {
    const [firstName, ...rest] = name.split(" ");

    return [firstName, rest.join(" ")];
};

export const getHubSpotUtkFromCookie = (cookie: string): string => {
    return cookie.replace(
        /(?:(?:^|.*;\s*)hubspotutk\s*=\s*([^;]*).*$)|^.*$/,
        "$1"
    );
};
